import React, { useState } from "react";
import axios from "axios";

function ImportProductsCsv() {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setStatus("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setStatus("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setStatus("Uploading and importing...");

      const res = await axios.post(
        "https://api.assortsmachinetools.com/admin/products/import-csv",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );

      // 🔥 Show full JSON so we can debug properly
      setStatus(JSON.stringify(res.data, null, 2));
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Import failed. Please check console.";
      setStatus("Error: " + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Import Products from CSV</h2>
      <p>
        CSV header must be:
        <br />
        <code>
          sku,categoryname,subcategoryName,details,productname,image1,image2,image3,image4,tableData,active,hotProduct
        </code>
      </p>

      <form onSubmit={handleSubmit} style={{ maxWidth: "400px" }}>
        <div style={{ marginBottom: "10px" }}>
          <input type="file" accept=".csv" onChange={handleFileChange} />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Importing..." : "Upload & Import"}
        </button>
      </form>

      {status && (
        <pre
          style={{
            marginTop: "15px",
            whiteSpace: "pre-wrap",
            background: "#111",
            color: "#0f0",
            padding: "10px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {status}
        </pre>
      )}
    </div>
  );
}

export default ImportProductsCsv;
   